import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASKET_DEAL_PRODUCT_DEPOSIT } from '../../brands/default/content/components/checkout';
import { formatCurrency } from '../../helpers/currency';
import { updateProductDeposit } from '../../redux/actions/basket';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';
import RadioButtonWithLabel from '../_generic/radio-button/RadioButtonWithLabel';

export default function BasketDealProductDeposit({ bt, deal, product }) {
  const dispatch = useDispatch();
  const disabled = useSelector(
    (state) =>
      state.checkout.status === CHECKOUT_STATUS.UPDATING ||
      state.checkout.status === CHECKOUT_STATUS.REFRESHING,
  );

  const onChangeDeposit = (event) => {
    dispatch(updateProductDeposit(bt, product, event.target.value));
  };

  return (
    <>
      <div className="deposit-radio-buttons">
        <div className="row">
          <div className="col-xs-12 col-md-9 col-lg-6">
            <RadioButtonWithLabel
              checked={product.payDeposit === true}
              disabled={disabled}
              key={`depositUseYes_${product.id}`}
              label={
                <span>
                  {BASKET_DEAL_PRODUCT_DEPOSIT.payDepositText}{' '}
                  {formatCurrency(
                    deal?.currency,
                    product.depositProduct.price,
                    true,
                    false,
                  )}
                </span>
              }
              onChange={onChangeDeposit}
              value
            />
            <RadioButtonWithLabel
              checked={product.payDeposit === false}
              disabled={disabled}
              key={`depositUseNo_${product.id}`}
              label={
                <span>
                  {BASKET_DEAL_PRODUCT_DEPOSIT.payFull}{' '}
                  {formatCurrency(deal?.currency, product.price, true, false)}
                </span>
              }
              onChange={onChangeDeposit}
              value={false}
            />
          </div>
        </div>
      </div>
      <style jsx>{`
        .deposit-radio-buttons {
          margin-bottom: 8px;
        }
      `}</style>
    </>
  );
}

BasketDealProductDeposit.propTypes = {
  bt: PropTypes.string,
  deal: PropTypes.object,
  product: PropTypes.object,
};
